import request from '../api/config';
async function GetGroup() {
  console.log(request.get(`/Grade/GetGroup`))
  return request.get(`/Grade/GetGroup`).then((res) => {
    if (res.success) {
      return res.dynamicObj;
    }
  }).catch(() => {

    return [];

  });

}
export default {
  GetGroup
}